export default __webpack_public_path__ + "static/media/thankyou.a96d09de.gif";